import React, { useMemo } from 'react';
import { BreadcrumbItem } from './BreadcrumbItem';
var Breadcrumbs = function (_a) {
    var className = _a.className, links = _a.links, isLastActive = _a.isLastActive;
    var getLinkBreadcrumb = useMemo(function () {
        if (links) {
            var breadCrumbsItems_1 = [];
            links.forEach(function (item, index) {
                var _a, _b, _c;
                breadCrumbsItems_1.push(React.createElement(BreadcrumbItem, { name: item.name, link: item.link, isShowChevron: index !== links.length - 1, isActive: isLastActive ? index === links.length - 1 : false, key: item.breadcrumbId, iconColor: (_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.iconColor, iconPath: (_b = item === null || item === void 0 ? void 0 : item.icon) === null || _b === void 0 ? void 0 : _b.iconPath, iconSize: (_c = item === null || item === void 0 ? void 0 : item.icon) === null || _c === void 0 ? void 0 : _c.iconSize, microdataMetaContent: index + 1 }));
            });
            return React.createElement(React.Fragment, null, breadCrumbsItems_1);
        }
    }, [isLastActive, links]);
    return (React.createElement("ul", { itemScope: true, itemType: 'https://schema.org/BreadcrumbList', className: 'breadcrumb ' + (className ? className : '') }, getLinkBreadcrumb));
};
export { Breadcrumbs };
//# sourceMappingURL=Breadcrumbs.js.map